<template>
  <v-row justify="center">
    <v-dialog scrollable v-model="dialog" persistent max-width="350">
      <v-card>
        <v-card-title class="d-flex flex-column text-h5">
          <div class="logoCont">
            <img ref="logoImage" :src="src" class="transparent mx-auto" />
          </div>
          {{ title }}
        </v-card-title>
        <v-card-text class="adModalText text-center">
          <span v-if="type != 'promotion'"> {{ message }} </span>
          <span v-else v-html="message"></span>
        </v-card-text>
        <v-card-actions>
          <span v-if="ad.dispatch.advertisement.must_agree != 0">
            <v-btn text color="switchq" @click="closeNotification">{{
              $t("confirm")
            }}</v-btn>
            <v-btn
              text
              v-if="ad.dispatch.advertisement.allow_disagree == 1"
              color="red"
              @click="disNotification"
              >{{ $t("decline") }}</v-btn
            >
            <v-btn
              v-if="ad.dispatch.advertisement.must_agree == 2"
              text
              color=""
              @click="dissmissAd"
              >{{ $t("cancel-for-now") }}</v-btn
            >
          </span>
          <span v-else>
            <v-btn text color="switchq" @click="closeNotification">{{
              $t("close")
            }}</v-btn>
          </span>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import auth from "@/helpers/auth";
export default {
  name: "AdvertisementModal",
  props: {
    activator: {
      type: Boolean,
      default: false,
    },
    ad: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: null,
    },
  },
  computed: {
    src() {
      const url = process.env.VUE_APP_ASSETS + "logo.png?token=";
      return url + auth.getToken();
    },
    dialog() {
      // get() {
      return this.activator;
      // },
      // set() {
      //   this.$emit("close", false);
      //   // this.activator = false;
      // },
    },
    title() {
      return this.ad.dispatch.advertisement.title
        ? this.ad.dispatch.advertisement.title
        : null;
    },
    message() {
      return this.ad.dispatch.advertisement.message;
    },
    slug() {
      return this.ad.dispatch.advertisement.slug;
    },
  },
  mounted() {},
  methods: {
    async closeNotification() {
      if (this.ad.watched_at == null || this.ad.watched_at == "") {
        if (this.type == "system") {
          await this.$store.dispatch(
            "systemAdvertisements/setWatched",
            this.slug
          );
        }
        if (this.type == "promotion") {
          await this.$store.dispatch(
            "promotionAdvertisements/setWatched",
            this.slug
          );
        }
      }
      this.dissmissAd();
      // this.dialog = false;
    },
    async disNotification() {
      // if (this.ad.watched_at == null || this.ad.watched_at == "") {
      if (this.type == "system") {
        await this.$store.dispatch(
          "systemAdvertisements/setDisWatched",
          this.slug
        );
      }
      if (this.type == "promotion") {
        await this.$store.dispatch(
          "promotionAdvertisements/setDisWatched",
          this.slug
        );
      }
      // }
      this.dissmissAd();
      // this.dialog = false;
    },
    async dissmissAd() {
      if (this.type == "system") {
        await this.$store.dispatch("systemAdvertisements/dissmiss", this.slug);
      }
      if (this.type == "promotion") {
        await this.$store.dispatch(
          "promotionAdvertisements/dissmiss",
          this.slug
        );
      }
      // this.dialog = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.v-icon {
  margin: 0 auto;
}
.v-dialog > .v-card > .v-card__actions {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.logoCont {
  display: flex;
  padding: 8px 16px;
  img {
    max-width: 40px;
    height: auto;
  }
}
</style>
